/* eslint-disable max-len */
import React from 'react';

const Grid = props => (
  <svg width={19} height={19} {...props}>
    <path
      fill="currentColor"
      d="M3 2h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v5h5V3H3zm8-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v5h5V3h-5zm0 7h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1zm0 1v5h5v-5h-5zm-8-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1zm0 1v5h5v-5H3z"
    />
  </svg>
);

export default Grid;
